import { useTranslation } from 'react-i18next';
import { Bot, FileText, Sparkles } from 'lucide-react';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Label,
  Switch
} from '@bliks-io/ui';

interface AiSettingsCardProps {
  bliksyEnabled: boolean;
  onToggleBliksyEnabled: (checked: boolean) => void;
  stepNameGenerationEnabled: boolean;
  onToggleStepNameGeneration: (checked: boolean) => void;
  className?: string;
}

export function AiSettingsCard({
  bliksyEnabled,
  onToggleBliksyEnabled,
  stepNameGenerationEnabled,
  onToggleStepNameGeneration,
  className
}: AiSettingsCardProps) {
  const { t } = useTranslation();

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Sparkles className="w-5 h-5 text-muted-foreground" />
          {t('OrgSettingPage.ai.title')}
        </CardTitle>
        <CardDescription>{t('OrgSettingPage.ai.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Feature Toggles */}
        <div className="flex items-center justify-between">
          <div className="flex items-start gap-3">
            <Bot className="w-5 h-5 mt-0.5 text-muted-foreground" />
            <div>
              <Label className="text-base font-medium">
                {t('OrgSettingPage.ai.bliksyEnableLabel')}
              </Label>
              <p className="text-sm text-muted-foreground">
                {t('OrgSettingPage.ai.bliksyEnableDescription')}
              </p>
            </div>
          </div>
          <Switch checked={bliksyEnabled} onCheckedChange={onToggleBliksyEnabled} />
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-start gap-3">
            <FileText className="w-5 h-5 mt-0.5 text-muted-foreground" />
            <div>
              <Label className="text-base font-medium">
                {t('OrgSettingPage.ai.stepNameGenerationLabel')}
              </Label>
              <p className="text-sm text-muted-foreground">
                {t('OrgSettingPage.ai.stepNameGenerationDescription')}
              </p>
            </div>
          </div>
          <Switch
            checked={stepNameGenerationEnabled}
            onCheckedChange={onToggleStepNameGeneration}
          />
        </div>
      </CardContent>
    </Card>
  );
}
